// extracted by mini-css-extract-plugin
export default {"processIA":"styles_processIA__qGhz0","is-transition":"styles_is-transition__j+KPQ","is-prev":"styles_is-prev__XdBZz","processIA__step":"styles_processIA__step__F0vsg"};